import styled from 'styled-components'
import theme from 'theme_'

export const StyledCommonLayout = styled.main`
  background-color: ${theme.colors.grey};
  padding-top: ${theme.sizes.headerHeight};
  min-height: calc(100vh - ${theme.sizes.footerHeight});
  max-width: ${theme.sizes.maxContentWidth};
  margin: 0 auto;
`

export const StyledOuterContainer = styled.div`
  padding: 0 12px;

  @media ${theme.devices.tablet} {
    padding: 0 24px;
  }
  @media ${theme.devices.mediumDesktop} {
    padding: 0 40px;
  }
`

export const StyledInnerContainerNearMenu = styled.main`
  margin-top: 80px;
  margin-left: 0;

  @media ${theme.devices.tablet} {
    margin-top: 0;
    margin-left: 96px;
  }
  @media ${theme.devices.mediumDesktop} {
    margin-top: 0;
    margin-left: 280px;
  }
`

export const StyledFadeInWrapper = styled.div`
  animation: ${theme.animations.fadeIn} 0.3s ease-out;
`

export const GoToTopContainer = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 48px;
  right: 20px;
  width: 40px;
  border-radius: 8px;
  background: #454443;
  border-radius: 8px;
  background-color: ${theme.colors.menuDark};
  width: 48px;
  height: 48px;
  padding: 0;
  margin: 0;
  outline: none;
  border: 0;
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s ease-in;
  z-index: ${theme.zIndex.homeAside};

  &.ToTopBtn--visible {
    opacity: 1;
  }

  @media ${theme.devices.mobile} {
    display: flex;
  }
`
